import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [9,[2]],
		"/(app)/admin": [10,[2]],
		"/(app)/admin/settings": [11,[2]],
		"/(app)/adoption-dashboard": [12,[2,3]],
		"/(app)/assistants": [13,[2]],
		"/auth": [50],
		"/auth/create-password": [51],
		"/auth/reset-password": [52],
		"/(app)/connections": [16,[2]],
		"/(app)/c": [14,[2,4]],
		"/(app)/c/[id]": [15,[2,4,5]],
		"/error": [53],
		"/(app)/quick_actions": [17,[2,6]],
		"/(app)/tutorials": [18,[2]],
		"/(app)/users": [19,[2]],
		"/(app)/workers": [20,[2]],
		"/(app)/workers/[id]": [21,[2]],
		"/(app)/workspace": [22,[2,7]],
		"/(app)/workspace/documents": [23,[2,7]],
		"/(app)/workspace/image-shortcuts": [24,[2,7,8]],
		"/(app)/workspace/image-shortcuts/edit": [25,[2,7,8]],
		"/(app)/workspace/image-styles": [26,[2,7]],
		"/(app)/workspace/image-styles/create": [27,[2,7]],
		"/(app)/workspace/image-styles/edit": [28,[2,7]],
		"/(app)/workspace/models": [29,[2,7]],
		"/(app)/workspace/models/create": [30,[2,7]],
		"/(app)/workspace/models/edit": [31,[2,7]],
		"/(app)/workspace/modules": [32,[2,7]],
		"/(app)/workspace/modules/create": [33,[2,7]],
		"/(app)/workspace/modules/edit": [34,[2,7]],
		"/(app)/workspace/quick-action-categories": [35,[2,7]],
		"/(app)/workspace/quick-action-categories/create": [36,[2,7]],
		"/(app)/workspace/quick-action-categories/edit": [37,[2,7]],
		"/(app)/workspace/quick-actions": [38,[2,7]],
		"/(app)/workspace/quick-actions/create": [39,[2,7]],
		"/(app)/workspace/quick-actions/edit": [40,[2,7]],
		"/(app)/workspace/smart-contexts": [41,[2,7]],
		"/(app)/workspace/smart-contexts/create": [42,[2,7]],
		"/(app)/workspace/smart-contexts/edit": [43,[2,7]],
		"/(app)/workspace/tutorials": [44,[2,7]],
		"/(app)/workspace/tutorials/create": [45,[2,7]],
		"/(app)/workspace/tutorials/edit": [46,[2,7]],
		"/(app)/workspace/workers": [47,[2,7]],
		"/(app)/workspace/workers/create": [48,[2,7]],
		"/(app)/workspace/workers/edit": [49,[2,7]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';